import axios from 'axios';
import { ElMessage } from 'element-plus';
import router from '@/router';

const baseUrl = process.env.VUE_APP_BASE_URL


// 响应拦截器
const responseInterceptor = (response) => {
  return response.data;
};

const errorInterceptor = (error, showError = true) => {
  if (error.response?.status === 401) {
    // 未授权，跳转登录页
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    router.push('/login');
    if (showError) {
      ElMessage.error('请先登录');
    }
  } else {
    if (showError) {
      // ElMessage.error(error.response?.data?.error || '请求失败');
      console.log('error',error)
      ElMessage.error(error.response?.data?.message || '请求失败');
    }
  }
  return Promise.reject(error);
};



const request = axios.create({
  baseURL: baseUrl,
  timeout: 6000
});

// 请求拦截器
request.interceptors.request.use(
  (config) => {
    console.log('请求config',config)
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

request.interceptors.response.use(responseInterceptor, (error) => errorInterceptor(error, true));


export const silentRequest = axios.create({
  baseURL: baseUrl,
  timeout: 300 * 1000
});

silentRequest.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

silentRequest.interceptors.response.use(responseInterceptor, (error) => errorInterceptor(error, false));

export default request;